export default __webpack_public_path__ + "static/media/rafSlide1.b54f920f.png";